import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { environments } from '../../environments/environments';

export const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const msalConfigB2b: Configuration = {
  auth: {
    clientId: environments.azureAdB2B.clientId,
    authority: environments.azureAdB2B.auth,
    redirectUri: environments.azureAdB2B.redirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIE,
  },
  system: {
    loggerOptions: {
      loggerCallback: (logLevel: LogLevel, message: string) => {
        console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
}

export const protectedResources = {
  guardaDigital: {
    endpoint: `${environments.api}`,
    scopes: environments.azureAdB2B.scopes,
  },
}

export const loginRequest = {
  scopes: []
};
